import { get, del } from "../../helpers/utils/http-client";
import {APPS_ENDPOINT} from '../../consts/api-endpoints';

export async function listDataSources(appId) {
    return await get(`${APPS_ENDPOINT}/${appId}/knowledge/data-sources`);
}

export async function viewDataSource(appId, dataSourceId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/knowledge/data-sources/${dataSourceId}/preview`);
        if (status !== 200) {
            throw new Error(response);
        }
        return { response, status };
    } catch (error) {
        return {
            status: error.status,
        };
    }
}

export async function deleteDataSources(appId, dataSourceId, returnOriginal='') {
    return await del(`${APPS_ENDPOINT}/${appId}/knowledge/data-sources/${dataSourceId}?returnOriginal=${returnOriginal}`);
}